import React, { useState, useEffect } from "react";
import axios from "axios";

const Distribution_Sucess = ({ office_code, version_date, dist_code,fps_id }) => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const sendRequest = async () => {
      try {
        const payload = {
          officeCode: [office_code],       
          versionDate: [version_date],   
          distCode: [dist_code],
          fps_id :[fps_id]          
        };

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/Tsoupdate`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              'X-React-Route': window.location.href
            } 
          }
        );

        setMessage(response.data); 
      } catch (error) {
        //console.error(" Error:", error);
        setMessage(" Distribution Update Failed (Server Error)");
      }
    };
    sendRequest();
  }, [office_code, version_date, dist_code]);

  return (
    <div className="p-6 text-center">
      
      {message ? (
        <div align="center" className="mainhead" >{message}: {}</div>
      ) : (
        <div align="center" >Processing request...</div>
      )} 
      <br/>
    </div>
    
  );
};
export default Distribution_Sucess;